import $ from 'jquery'
import TableCellRenderer from '../../../../table/TableCellRenderer'
import messageResource from '../../../../messageResource'
import NameCellContent from './NameCellContent'

class NameCellRenderer extends TableCellRenderer {

    init({
        tokensHighlighter,
        isEditingAllowed,
        hasApprover,
        onClickCb,
        warningsController,
        onMouseIn,
        onMouseOut,
    }) {
        TableCellRenderer.call(this);
        this.tokensHighlighter = tokensHighlighter;
        this.isEditingAllowed = isEditingAllowed;
        this.onClickCb = onClickCb


        this.warningsController = warningsController;

        this.params = {
            hasApprover,
            onMouseIn,
            onMouseOut,
        }

        return this;
    }

    generateContent(cell) {
        const cellEl = cell.getCellEl();
        const $cell = $(cellEl);

        this.content = new NameCellContent({
            warningsController: this.warningsController,
            onClick: (e) => {
                if (this.isEditingAllowed && !cell.getValue().locked) {
                    this.onClickCb(cell, e)
                }
            },
            onMouseIn: (e) => {
                if (this.isEditingAllowed && !cell.getValue().locked) {
                    this.params.onMouseIn(cell, e)
                    $cell.addClass("hovered")
                }
            },
            onMouseOut: (e) => {
                if (this.isEditingAllowed && !cell.getValue().locked) {
                    this.params.onMouseOut(cell, e)
                    $cell.removeClass("hovered");
                }
            }
        }).init($cell)

        this.content.setState({
            userGroupName: cell.getGroupName(),
            timeZoneGroupName: cell.getTimeZoneGroupName(),
            infos: cell.infos,
            warnings: cell.warnings,
            firstName: cell.getValue().firstName,
            lastName: cell.getValue().lastName,
            username: cell.getValue().username,
            middleInitial: cell.getValue().middleInitial,
            clickable: cell.getValue().editable,
            locked: cell.getValue().locked,
            highlighter: this.tokensHighlighter,
        })


        if (this.isEditingAllowed && cell.getValue().locked) {
            cellEl.title = messageResource.getMessage("user.edit.js.user_is_locked");
        }

        this.updateContent(cell)
    }

    updateContent(cell) {
        this.content.setState({
            withoutApprover: cell.getValue().requiresTTApproval && !this.params.hasApprover,
            userGroupName: cell.groupName,
            timeZoneGroupName: cell.timeZoneGroupName,
        })
    }

    getCellClassName() {
        return ["userNameCell"];
    }

    updateGroupName(cell) {
        this.updateContent(cell)
    }

    updateTimeZoneGroupName(cell) {
        this.updateContent(cell)
    }

    updateUsersWithoutApproval(cell, hasApprover) {
        this.params.hasApprover = hasApprover
        this.updateContent(cell)
    }
}

export default NameCellRenderer



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/NameCellRenderer.js